<p>
  codificatore-controllo-file works!
</p>
